export default "__VITE_ASSET__590270b9__"